import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getConsent, setConsent, loadAnalyticsScripts } from "../../utils/cookieConsent";

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const existing = getConsent();
    if (existing === "accepted") {
      loadAnalyticsScripts();
    } else if (existing === null) {
      setVisible(true);
    }

    const handleOpenPreferences = () => setVisible(true);
    window.addEventListener("opencookiepreferences", handleOpenPreferences);
    return () =>
      window.removeEventListener("opencookiepreferences", handleOpenPreferences);
  }, []);

  const handleAccept = () => {
    setConsent("accepted");
    loadAnalyticsScripts();
    setVisible(false);
  };

  const handleReject = () => {
    setConsent("rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie preferences"
      className="fixed inset-x-0 bottom-0 z-[60] border-t border-white/10 bg-[var(--surface-dark)] px-4 py-5 text-white shadow-[0_-4px_20px_rgba(0,0,0,0.35)] sm:px-6"
    >
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 sm:flex-row sm:justify-between">
        <p className="text-sm leading-relaxed text-slate-200 sm:max-w-2xl">
          We use necessary cookies to run this site, and — only with your permission —
          analytics cookies (Google Analytics, Microsoft Clarity) to understand how
          visitors use it. See our{" "}
          <Link
            to="/legal/cookies"
            className="underline decoration-white/40 underline-offset-2 hover:decoration-white"
          >
            Cookie Policy
          </Link>{" "}
          for details.
        </p>
        <div className="flex flex-shrink-0 gap-3">
          <button
            type="button"
            onClick={handleReject}
            className="rounded-full border border-white/20 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-white/10"
          >
            Necessary Only
          </button>
          <button
            type="button"
            onClick={handleAccept}
            className="rounded-full bg-[var(--website-secondary-color)] px-5 py-2.5 text-sm font-semibold text-[var(--on-secondary)] transition hover:brightness-110"
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
